/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, {
  useContext,
  useState,
  useEffect,
  // useMemo,
  useCallback,
  useMemo,
} from 'react'
import R from 'ramda'
import MarginAnalysisContext from './MarginAnalysisContext'
import ScenarioDialog from './component/ScenarioDialog'
import { SpinContext, ErrorContext } from 'context'
import {
  marginAnalysisValidate,
  marginAnalysisExportBlob,
  marginAnalysisValidateBS,
  getMarginAnalysisRecallRetrieveData,
} from 'api/pgads'
import {
  getUnitNameMap,
  getApiTargetInfo,
  getUtilityNameMap,
  getUnits,
  getClientInfo,
  getPermitActions,
  getEnvConfig,
  hasAccesPermits,
  getUserInfo,
} from 'core'
import { connect } from 'react-redux'
import { Button, message, Modal, Select, Tooltip } from 'antd'
import CostGridWF from './component/CostGridWF'
import PriceEditWF from './component/PriceEditWF'
import {
  Content,
  FullHeightSizer,
  // Filler,
  CriteriaRow,
  Title,
  Label,
} from 'core/screen-util'
import MarginCard97EventDialog from './component/MarginCard97EventDialog'
import EvendDataWF from './component/EventDataWF'
import EventPlannerDialog from './component/EventPlannerDialogWF'
import LostMarginRechartPie from './component/LostMarginRechartPie'
import CommercialPieRechart from './component/CommercialPieRechart'
import MonthlyGraphData from './component/MonthlyDataGraph'
import EventTotals from './component/EventTotals'
import SaveScenarioDoalog from './component/SaveScenarioDialog'
import moment from 'moment'
import HourlyDetailsModal from './component/HourlyDetailsModal'
import { getExportDataHeaders } from './margin-client'

import * as ScreenPermissions from 'core/EventActions'

import { toXlsxColumns, toXlsxData, writeToExcel } from './Headers'

import { saveAs } from 'file-saver'
import { KINDLE_CLIENT } from 'client'
import { isErrorContains } from 'core/component/JcTmpErrorDialog'
import JcTmpErrorContext from 'context/JcTmpErrorContext'
import { freeEditEngine } from '@integec/grid-tools'
import { decompressJsonData } from './../compress-utils'

const MarginAnalysisWhatIf = ({
  targetInfo,
  CLIENT,
  actionPermits,
  envConfig,
  userInfo,
  ...props
}) => {
  const {
    WFRetrieveData,
    setWFRetrievedData,
    handleWFRetrieveData,
    removeEventData,
    // scenarioList,
    setScenarioList,
    selectedScenario,
    setSelectedScenario,
    WFSelectedEvent,
    reloadScenario,
    setWFSelectedEvents,
    selectedDateRangePicker,
    setSelectedDateRagePicker,
    lostType,
    setLostType,
    eventDataEditInfo,
  } = useContext(MarginAnalysisContext)

  // const { userInfo } = useContext(ClientContext)
  const [eventPlanner, setEventPlanner] = useState(false)
  const [showScneriaDialog, setShowScneriaDialog] = useState(false)
  const [showSaveScenarioDoalog, setSaveScenariodialog] = useState(false)
  const [showHourlyDetails, setShowHourlyDetails] = useState(false)

  const { setTmpError } = useContext(JcTmpErrorContext)

  useEffect(
    _ => {
      if (R.isEmpty(userInfo)) return

      const compressDataFromCookie =
        window?.localStorage?.getItem(userInfo.userName + '_whatifCookie') ||
        '{}'
      const dataFromCookie = decompressJsonData(compressDataFromCookie)

      if (!R.isEmpty(dataFromCookie)) {
        const scenario = dataFromCookie?.request?.scenario
        setWFRetrievedData(dataFromCookie)
        setSelectedScenario(scenario)
        setSelectedDateRagePicker([
          moment(scenario.startdate),
          moment(scenario.enddate),
        ])

        window.localStorage.removeItem(userInfo.userName + '_whatifCookie')
      } else if (
        !selectedScenario ||
        Object.keys(selectedScenario).length <= 0
      ) {
        setShowScneriaDialog(true)
      }
    },
    [
      selectedScenario,
      setSelectedDateRagePicker,
      setSelectedScenario,
      setWFRetrievedData,
      userInfo,
    ]
  )

  const whatIfAdmin = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MARGIN_ANALYSIS_ADMIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const hideEventPlanner = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.MARGIN_ANALYSIS_HIDE_EVENTPLANNER],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const openScneriaDialog = _ => setShowScneriaDialog(true)

  const onCloseScenarioDialog = selectedScenario => {
    setSelectedScenario(selectedScenario)
    setShowScneriaDialog(false)
    setSelectedDateRagePicker([
      moment(selectedScenario.startdate),
      moment(selectedScenario.enddate),
    ])
  }
  const onCancelScenarioDialog = _ => setShowScneriaDialog(false)
  const { setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)

  const reloadScnerioList = useCallback(
    _ => {
      reloadScenario(targetInfo)
    },
    [reloadScenario, targetInfo]
  )

  useEffect(reloadScnerioList, [
    reloadScnerioList,
    setError,
    targetInfo,
    setScenarioList,
  ])

  const width = 800
  const height = 400

  const pichartWidth = 550
  const actualHeight = 230

  const reCalculate = _ => {
    setSpinning(true)
    const { events } = WFRetrieveData
    const saveEventData = freeEditEngine.applyEdits({
      data: events,
      editInfo: eventDataEditInfo,
    })
    marginAnalysisValidate(targetInfo)({
      ...WFRetrieveData,
      events: saveEventData,
      request: { ...WFRetrieveData.request, lostType, mode: 'WHATIF' },
    }).fork(setError, data => {
      setSpinning(false)
      handleWFRetrieveData(data)
    })
  }

  const bestScenario = _ => {
    setSpinning(true)
    marginAnalysisValidateBS(targetInfo)({
      ...WFRetrieveData,
      request: { ...WFRetrieveData.request, lostType, mode: 'WHATIF_BS' },
    }).fork(setError, data => {
      setSpinning(false)
      handleWFRetrieveData(data)
    })
  }

  const closeSaveScenarioDoalog = _ => setSaveScenariodialog(false)
  const showHourlyDialog = _ => {
    setShowHourlyDetails(true)
  }

  const exportMarginData = _ => {
    // marginAnalysisExportData(targetInfo)(retrievedData).fork(setError, res => {
    //   setSpinning(false)
    //   exportData(res, 'application/pdf', 'ma')
    // })

    const selUnit =
      props.unitNameMap[selectedScenario.utility + '' + selectedScenario.unit]

    const sd = `${selectedDateRangePicker[0].format('YYYY-MMM-DD')}`
    const ed = `${selectedDateRangePicker[1].format('YYYY-MMM-DD')}`
    const fileNAme = 'ma-' + selUnit + '-' + sd + '_' + ed + '.pdf'

    setSpinning(true)
    marginAnalysisExportBlob(targetInfo)(
      WFRetrieveData,
      {
        byCausecode: false,
      },
      fileNAme
    )(_ => setSpinning(false))
  }

  const exportData = async _ => {
    const { hourlyExportData = [] } = WFRetrieveData
    const exportHeader = getExportDataHeaders(CLIENT)

    const columns = toXlsxColumns(exportHeader)
    setSpinning(true)

    const ed = toXlsxData(hourlyExportData, exportHeader)

    const worksheet = [
      {
        // name: 'sheet1',
        columns,
        data: ed,
        metaInfo: [],
        colorInfo: [],
      },
    ]

    const fileBlob = await writeToExcel(worksheet)
    setSpinning(false)
    saveAs(fileBlob, 'ma-events-whatif')
  }

  const [showCardDialog, setShowCardDialog] = useState(false)
  const openCardEditDialog = type => {
    if (type !== 1) {
      if (!WFSelectedEvent) {
        message.warning(
          'Please, Select record for ' + type === 2 ? 'Update' : 'Remove'
        )
        return
      }
    } else {
      // eslint-disable-next-line no-unused-vars
      const { scenario, ...remaining } = WFRetrieveData.request
      setWFSelectedEvents({ ...remaining, unitname: 'DETAIL' })
    }
    setShowCardDialog(type)
  }
  const removeEventDataConformation = _ => {
    Modal.confirm({
      content:
        'Do you want to Delete selected event (Event# ' +
        WFSelectedEvent.eventnum +
        ')?',
      title: 'Delete Card97-Event Data',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        removeEventData()
      },
      onCancel() {},
    })
  }
  const [showPricedialog, setShowPricedialog] = useState(false)
  const [showCostDialog, setShowCostDialog] = useState(false)

  const reCallDataRetrieve = _ => {
    const { scenarioId } = selectedScenario

    if (!scenarioId) {
      message.warning(
        'Please save the base scenario before new calculation is applied.'
      )
      setSaveScenariodialog(true)
      return
    }

    const reqData = {
      mode: 'WHATIF',
      startDate: selectedScenario.startdate, // .format('YYYY-MM-DD'),
      endDate: selectedScenario.enddate, // .format('YYYY-MM-DD'),
      utility: selectedScenario.utility,
      unit: selectedScenario.unit,
      emktId: selectedScenario.unitid,
      scenario: selectedScenario,
      showCauseCode: false,
      lostType,
    }

    setSpinning(true)
    getMarginAnalysisRecallRetrieveData(targetInfo)(reqData).fork(
      error => {
        setError(error)
      },
      data => {
        setSpinning(false)
        if (!isErrorContains(data.errors)) {
          handleWFRetrieveData(data)
        } else {
          setTmpError(data.errors)
        }
      }
    )
  }

  return (
    <React.Fragment>
      {showCostDialog && (
        <CostGridWF
          targetInfo={targetInfo}
          CLIENT={CLIENT}
          height={400}
          width={1200}
          onClose={_ => setShowCostDialog(false)}
          visible={showCostDialog}
          whatIfAdmin={whatIfAdmin}
          lostType={lostType}
        />
      )}
      {showPricedialog && (
        <PriceEditWF
          targetInfo={targetInfo}
          CLIENT={CLIENT}
          height={400}
          width={1200}
          visible={showPricedialog}
          onClose={_ => setShowPricedialog(false)}
          whatIfAdmin={whatIfAdmin}
          lostType={lostType}
        />
      )}
      {showCardDialog && (
        <MarginCard97EventDialog
          CLIENT={CLIENT}
          height={height}
          width={width}
          // WFSelectedEvent={WFSelectedEvent}
          visible={!!showCardDialog}
          onClose={_ => setShowCardDialog(false)}
          type={showCardDialog}
          lostType={lostType}
        />
      )}
      {showHourlyDetails && (
        <HourlyDetailsModal
          visible={showHourlyDetails}
          setClose={_ => setShowHourlyDetails(false)}
          whatIf
          unitId={selectedScenario.utility + '' + selectedScenario.unit}
          lostType={lostType}
        />
      )}
      {showSaveScenarioDoalog && (
        <SaveScenarioDoalog
          targetInfo={targetInfo}
          onCancelScenarioDialog={closeSaveScenarioDoalog}
          onClose={closeSaveScenarioDoalog}
          visible={showSaveScenarioDoalog}
          userInfo={userInfo}
          lostType={lostType}
        />
      )}
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns:
              '150px auto auto auto min-content auto auto auto auto',
            gap: '5px',
            overflowX: 'auto',
          }}
        >
          {/* <div
            style={{
              display: 'grid',
              gridColumnGap: '5px',
              gridTemplateColumns: '150px 150px 150px 200px',
            }}
          > */}

          <Title style={{ color: 'red' }}>What-If Scenario</Title>
          {/* <div style={{ color: 'red' }}>Whatif-Scenario</div> */}
          <Tooltip placement="bottomLeft" title={selectedScenario.comments}>
            <Title>
              {selectedScenario.isNew
                ? '*New Scenario'
                : selectedScenario.scenarioName}
            </Title>
          </Tooltip>
          <div
            style={{
              alignContent: 'center',
              display: 'grid',
              fontSize: 'larger',
            }}
          >
            {
              props.unitNameMap[
                selectedScenario.utility + '' + selectedScenario.unit
              ]
            }
            ({selectedScenario.utility}-{selectedScenario.unit})
          </div>
          <div style={{ alignContent: 'center', display: 'grid' }}>
            {moment(selectedScenario.startdate).format('MM/DD/YYYY')}
            {' - '}
            {moment(selectedScenario.enddate).format('MM/DD/YYYY')}
          </div>
          {/* </div> */}

          <Button onClick={openScneriaDialog} type="primary">
            Recall Scenario
          </Button>

          {WFRetrieveData.dls && (
            <Button onClick={showHourlyDialog} type="primary">
              Hourly Detail
            </Button>
          )}
          {WFRetrieveData.dls && (
            <Button onClick={exportMarginData}>Export To PDF</Button>
          )}
          {WFRetrieveData.dls && (
            <Button onClick={exportData}>Export Data</Button>
          )}
          {whatIfAdmin && WFRetrieveData.dls && (
            <Button onClick={_ => setSaveScenariodialog(true)} type="primary">
              Save Scenario
            </Button>
          )}
          {CLIENT === KINDLE_CLIENT && (
            <React.Fragment
              style={{
                display: 'flex',
                // gridTemplateColumns: '20% 80%',
                // marginLeft: '5px',
                // marginRight: '5px',
                // marginTop: '5px',
                // justifyContent: 'left',
                // gridColumnEnd: 'span 2',
              }}
            >
              <Label css={{ justifyContent: 'right' }}>
                Lost Margin Types :
              </Label>
              <Select
                value={lostType}
                onChange={lost => setLostType(lost)}
                style={{
                  marginRight: '5px',
                  marginLeft: '5px',
                  width: '100%',
                  gridColumnEnd: 'span 3',
                }}
              >
                <Select.Option value={1}>All Lost Margins</Select.Option>
                <Select.Option value={2}>
                  Only Forced and Maintenance Lost Margins
                </Select.Option>
                <Select.Option value={3}>
                  Only Forced, Maintenance and Planned Lost Margins
                </Select.Option>
                <Select.Option value={4}>
                  Only Market Lost Margins
                </Select.Option>
              </Select>
              <Button
                style={{ marginLeft: '5px' }}
                onClick={reCallDataRetrieve}
                type="primary"
              >
                Apply
              </Button>
            </React.Fragment>
          )}
        </div>
      </CriteriaRow>
      <FullHeightSizer heightOffset={240}>
        {({ height, width }) => {
          return (
            <Content
              style={{
                height: height + 20,
                display: 'grid',
                gridTemplateRows: 'min-content  min-content auto 80px',
                gridRowGap: '5px',
                overflowY: 'auto',
              }}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns:
                    'min-content min-content min-content min-content',
                  gridTemplateRows: 'min-content',
                }}
              >
                <CommercialPieRechart
                  whatIf
                  actualWidth={pichartWidth}
                  actualHeight={actualHeight}
                  extraWidth={250}
                />
                <LostMarginRechartPie
                  whatIf
                  actualWidth={pichartWidth}
                  actualHeight={actualHeight}
                  extraWidth={250}
                />
                <MonthlyGraphData
                  whatIf
                  actualWidth={700}
                  actualHeight={actualHeight}
                />
              </div>
              <div style={{ display: 'flex', gap: '10px', flexFlow: 'nowrap' }}>
                {whatIfAdmin && WFRetrieveData.dls && (
                  <React.Fragment>
                    <Button onClick={_ => openCardEditDialog(1)} type="primary">
                      Create Event
                    </Button>
                    <Button onClick={_ => openCardEditDialog(2)} type="primary">
                      Edit Event
                    </Button>
                    <Button onClick={removeEventDataConformation} type="danger">
                      Remove Event
                    </Button>
                  </React.Fragment>
                )}
                <div style={{ width: '100px' }} />
                {WFRetrieveData.dls && (
                  <Button
                    onClick={_ => setShowPricedialog(true)}
                    type="primary"
                  >
                    {whatIfAdmin && WFRetrieveData.dls
                      ? 'Edit Prices'
                      : 'View Prices'}
                  </Button>
                )}
                {WFRetrieveData.dls && (
                  <Button onClick={_ => setShowCostDialog(true)} type="primary">
                    {whatIfAdmin ? 'Edit Constraints' : 'View Constraints'}
                  </Button>
                )}
                <div style={{ width: '100px' }} />
                {WFRetrieveData.dls && !hideEventPlanner && (
                  <Button onClick={_ => setEventPlanner(true)} type="primary">
                    Event Planner
                  </Button>
                )}

                {whatIfAdmin && WFRetrieveData.dls && (
                  <Button onClick={reCalculate} type="primary">
                    Re-Calculate
                  </Button>
                )}
                <div style={{ width: '100px' }} />
                {whatIfAdmin && WFRetrieveData.dls && (
                  <Button onClick={bestScenario} type="primary">
                    Best Scenario
                  </Button>
                )}
              </div>
              <EvendDataWF
                CLIENT={CLIENT}
                height={height - 300 - 70}
                width={width - 50}
                writePermission={whatIfAdmin}
              />
              <EventTotals
                whatIf
                width={width - 50}
                height={70}
                CLIENT={CLIENT}
              />
              {showScneriaDialog && (
                <ScenarioDialog
                  onClose={onCloseScenarioDialog}
                  visible={showScneriaDialog}
                  targetInfo={targetInfo}
                  onCancelScenarioDialog={onCancelScenarioDialog}
                  lostType={lostType}
                />
              )}
            </Content>
          )
        }}
      </FullHeightSizer>

      {eventPlanner && (
        <EventPlannerDialog
          visible={eventPlanner}
          onOk={_ => setEventPlanner(false)}
          onClose={_ => setEventPlanner(false)}
          targetInfo={targetInfo}
          whatIf
          lostType={lostType}
        />
      )}
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  units: getUnits(state),
  targetInfo: getApiTargetInfo(state),
  CLIENT: getClientInfo(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  userInfo: getUserInfo(state),
})
export default connect(mapStateToProps)(MarginAnalysisWhatIf)
